import React from 'react'

const TopicsList = ({ topics, onClick }) => {
	const noTopics = topics.length === 0
	if(noTopics) {
		return (
			<div>Aucun sujet à afficher</div>
		)
	}
	return (
		<ul>
			{topics.map(topic =>
				<li key={topic.title}>
					<h2>{ topic.title }</h2>
					<ul>
						{topic.questions.map(question =>
							<li key={question.title} className="faq__answer" onClick={() => onClick(question)}>{ question.title }</li>
						)}
					</ul>
				</li>
			)}
		</ul>
	)
}

export default TopicsList



// WEBPACK FOOTER //
// ./src/js/faq/TopicsList.js